"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @private
 */
exports.USER_COMPANY_USER_DOCUMENTS_ENDPOINT = {
    addUserDocumentation: '/user-company/{{version}}/users/{{userUuid}}/documentation',
    putValidateDrivingLicense: '/user-company/{{version}}/users/{{userUuid}}/driving-licenses/validate',
};
